<template>
	<div>
		<p>
			{{
				selectRandom(["We searched ", "Databases used for the search were "])
			}}
			{{ joinArrayWithAnd(formatSelectMulti($tera.project.databases)) }}
			{{
				selectRandom([
					"from ",
					". Searchers were run from ",
					". Databases were searched from "
				])
			}}
			{{
				$tera.project.dateSearchedUntil
					? formatDateFull($tera.project.dateSearchedUntil)
					: "inception"
			}}
			{{ selectRandom(["to ", "until "]) }}
			{{
				$tera.project.dateOfSearch
					? formatDateFull($tera.project.dateOfSearch)
					: "BLANK"
			}}
			(see Appendix X).
		</p>

		<p>
			{{
				selectRandom([
					"We searched ",
					"Trial registries used for the search were ",
					"The following trial registries were searched ",
					"To identify ongoing studies, we searched "
				])
			}}
			{{ joinArrayWithAnd(formatSelectMulti($tera.project.registries)) }}
			{{
				selectRandom([
					"from ",
					". Searches were run from ",
					". They were searched from "
				])
			}}
			{{
				$tera.project.registryDateSearchedUntil
					? formatDateFull($tera.project.registryDateSearchedUntil)
					: "inception"
			}}
			{{ selectRandom(["to ", "until "]) }}
			{{
				$tera.project.registryDateOfSearch
					? formatDateFull($tera.project.registryDateOfSearch)
					: "BLANK"
			}}
			(see Appendix Y).
		</p>
		<!--Appendix : showAll: FALSE unless it in the ViewOutput (All Appendix are gathered together showing at the bottom)-->
		<div v-if="showAppendix">
			<OutputAppendix method="SearchStrings" :showAll="false" />
		</div>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
import OutputAppendix from "./OutputAppendix.vue";
export default {
	name: "OutputSearchStrings",
	mixins: [OutputMixin],
	components: {
		OutputAppendix
	},
	props: {
		showAppendix: Boolean
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
